import React, { useState } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { formatShippingTypes, getOrderStatus } from 'helpers/format'
import { Data } from 'Store/orders/types'
import InfoItem from './InfoItem'
import { Col, Row } from 'antd'
import { StatusTag } from 'Components/utilities'
import LinkText from 'Components/text/LinkText'
import Theme from 'Components/common/Theme'
import OrderLogsDrawer from './OrderLogsDrawer'
import { DeliveryType, OrderStatus, PaymentType } from 'helpers/constanst'

type Props = {
  detail?: Data
  status: string
}

const PaymentInfo: React.FunctionComponent<Props> = props => {
  const [showOrderLogs, sethowOrderLogs] = useState(false)
  const { detail, status } = props
  const shippingType = detail?.products[0]?.products[0]?.shipping_detail?.delivery_by || ''
  const trackingNumber = detail?.products[0]?.products[0]?.shipping_detail?.tracking_number || ''

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const renderStatus = (status: string) => {
    const result = getOrderStatus(status)
    return <StatusTag color={result.color} text={result.text} />
  }

  const OrderLogs = (
    <OrderLogsDrawer
      isShow={showOrderLogs}
      onClose={() => sethowOrderLogs(false)}
      orderNo={detail?.order_no || ''}
      isPublicDelivery={shippingType === DeliveryType.PUBLIC}
      trackingNumber={trackingNumber}
      paymentStatus={detail?.payment_status || ''}
      isCod={detail?.payment_detail?.payment_type === PaymentType.COD}
    />
  )

  return (
    <BoxWrapper>
      <Row gutter={[16, 16]}>
        <Col md={24} xs={24}>
          <Row justify="space-between">
            <Col>
              <BoxTitle>รายละเอียดการสั่งซื้อ</BoxTitle>
            </Col>
            <Col>
              <Link color={Theme.colors.primary} onClick={() => sethowOrderLogs(true)}>
                ตรวจสอบสถานะคำสั่งซื้อ
              </Link>
            </Col>
          </Row>
          {renderInfo('จัดส่งโดย', formatShippingTypes(shippingType))}
          {trackingNumber && renderInfo('หมายเลขติดตามสถานะขนส่ง BEST Express', trackingNumber)}
          {renderInfo('สถานะคำสั่งซื้อ', renderStatus(status))}
          {status === OrderStatus.CANCEL &&
            renderInfo('เหตุผลการยกเลิก', (detail?.products && detail?.products[0]?.reason) || '-')}
          {OrderLogs}
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Link = styled(LinkText)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

export default PaymentInfo
